import {
    FAILURE_SCELLIUS_FORM_TOKEN,
    RECEIVE_SCELLIUS_FORM_TOKEN,
    REQUEST_SCELLIUS_FORM_TOKEN,
    RESET_SCELLIUS
} from './constants';

const defaultState = {
    loading: true,
    formToken: null
};

const scelliusReducer = (state = defaultState, action) => {
    switch (action.type) {
        case REQUEST_SCELLIUS_FORM_TOKEN: {
            return state;
        }
        case RECEIVE_SCELLIUS_FORM_TOKEN: {
            return {
                loading: false,
                formToken: action.response.payload.formToken,
                successUrl: action.response.payload.successUrl,
                errorUrl: action.response.payload.errorUrl
            };
        }
        case FAILURE_SCELLIUS_FORM_TOKEN: {
            return {
                ...state,
                loading: false,
                error: action.response.error
            };
        }
        case RESET_SCELLIUS: {
            return {
                loading: false,
                formToken: null,
                successUrl: null,
                errorUrl: null
            };
        }
        default: {
            return state;
        }
    }
};

export default scelliusReducer;



// WEBPACK FOOTER //
// ./src/services/scellius/reducer.js